export const currencyOptions = [
    { id: 'RUB', name: 'Российский рубль' },
    { id: 'AZN', name: 'Азербайджанский манат' },
    { id: 'KZT', name: 'Казахстанский тенге' },
    { id: 'UZS', name: 'Узбекский сум' },
    { id: 'BRL', name: 'Brazilian real' },
    { id: 'AED', name: 'UAE Dirham' },
    { id: 'ILS', name: 'Israeli Shekel' },
    { id: 'USD', name: 'American Dollar' },
];
